/**
 * Mobile Homepage Enhancements
 * Only executes on viewports <= 749px
 */

(function () {
  'use strict';

  function isMobile() {
    return window.innerWidth <= 749;
  }

  /* -----------------------------------------------
     1. Multicolumn Carousel — full-width, dots,
        arrows flanking image, autoplay, swipe
     ----------------------------------------------- */
  function initMobileCarousels() {
    if (!isMobile()) return;

    var multicolumnSections = document.querySelectorAll('.section-multicolumn');

    multicolumnSections.forEach(function (section) {
      var carouselEl = section.querySelector('splide-carousel');
      if (!carouselEl) return;

      var splideRoot = carouselEl.querySelector('.splide');
      if (!splideRoot) return;

      var slides = splideRoot.querySelectorAll('.splide__slide');
      if (slides.length <= 1) return;

      // Wait for the Splide instance to be ready
      var attempts = 0;
      var checkReady = setInterval(function () {
        attempts++;
        if (carouselEl.slideInstance || attempts > 50) {
          clearInterval(checkReady);
          if (carouselEl.slideInstance) {
            reinitCarousel(section, carouselEl, splideRoot, slides.length);
          }
        }
      }, 100);
    });
  }

  function reinitCarousel(section, carouselEl, splideRoot, slideCount) {
    if (!isMobile()) return;

    // Destroy existing instance
    try {
      if (carouselEl.slideInstance) {
        carouselEl.slideInstance.destroy();
      }
    } catch (e) {}

    var direction = document.documentElement.getAttribute('dir') || 'ltr';

    // Create new Splide with mobile-optimized options
    // Note: no fixedWidth — slides are full viewport width
    var newSplide = new Splide(splideRoot, {
      direction: direction,
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: '0rem',
      arrows: false,
      pagination: true,
      autoplay: true,
      interval: 4000,
      pauseOnHover: true,
      pauseOnFocus: true,
      speed: 500,
      drag: true,
      rewind: false,
      flickPower: 300,
      // Override the breakpoint that sets fixedWidth
      breakpoints: {
        749: {
          fixedWidth: false,
          perPage: 1,
          gap: '0rem',
        }
      }
    });

    newSplide.mount();

    // Explicitly start autoplay after mount (destroy/reinit can leave it paused)
    try {
      newSplide.Components.Autoplay.play();
    } catch (e) {}

    // Store reference
    carouselEl.slideInstance = newSplide;
    section._mobileSplide = newSplide;

    // Add custom mobile arrows flanking the image
    addMobileArrows(section, newSplide);

    // Pause/resume auto-advance on interaction
    var resumeTimer = null;

    function pauseAndResume() {
      try {
        newSplide.Components.Autoplay.pause();
      } catch (e) {}
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        try {
          newSplide.Components.Autoplay.play();
        } catch (e) {}
      }, 5000);
    }

    newSplide.on('drag', pauseAndResume);
    newSplide.on('arrows:clicked', pauseAndResume);
  }

  function addMobileArrows(section, splide) {
    var existing = section.querySelector('.mobile-carousel-arrows');
    if (existing) existing.remove();

    // Arrows appended to the section — position:absolute spans full section width,
    // while the track is narrowed to 82% via CSS, leaving gutters for the arrows.
    var arrowsDiv = document.createElement('div');
    arrowsDiv.className = 'mobile-carousel-arrows';

    var dir = document.documentElement.getAttribute('dir');

    // In RTL (Hebrew): "previous" goes right (‹ points right), "next" goes left (› points left)
    // SVG: points-left chevron = "15 18 9 12 15 6", points-right chevron = "9 6 15 12 9 18"
    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous');

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next');

    if (dir === 'rtl') {
      // RTL: left side shows left-pointing chevron (goes to next in RTL)
      //      right side shows right-pointing chevron (goes to prev in RTL)
      // Left-pointing SVG: points="15 18 9 12 15 6"
      // Right-pointing SVG: points="9 6 15 12 9 18"
      nextBtn.innerHTML =
        '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      prevBtn.innerHTML =
        '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="9 6 15 12 9 18"></polyline></svg>';
      // LEFT side = nextBtn (left-pointing ‹), RIGHT side = prevBtn (right-pointing ›)
      arrowsDiv.appendChild(nextBtn);
      arrowsDiv.appendChild(prevBtn);
    } else {
      // LTR: left-pointing on LEFT = prev, right-pointing on RIGHT = next
      prevBtn.innerHTML =
        '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      nextBtn.innerHTML =
        '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="9 6 15 12 9 18"></polyline></svg>';
      arrowsDiv.appendChild(prevBtn);
      arrowsDiv.appendChild(nextBtn);
    }

    section.appendChild(arrowsDiv);

    prevBtn.addEventListener('click', function () {
      splide.go('<');
    });

    nextBtn.addEventListener('click', function () {
      splide.go('>');
    });
  }

  /* -----------------------------------------------
     3. Back to Top — smooth scroll
     ----------------------------------------------- */
  function initBackToTop() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.back-to-top-link')) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  /* -----------------------------------------------
     Init on DOM ready
     ----------------------------------------------- */
  function init() {
    initMobileCarousels();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
